import { routeFor } from '@platform/app-kit';

/** The contract routes the console's pages lead to; guards and the menu gate on these. */
export const TENANTS_ROUTE = routeFor('platform', 'Tenants_list');
export const TENANT_ROUTE = routeFor('platform', 'Tenants_get');
export const SUSPEND_ROUTE = routeFor('platform', 'Tenants_suspend');
export const RESUME_ROUTE = routeFor('platform', 'Tenants_resume');
export const REAPPLY_ROUTE = routeFor('platform', 'Tenants_reapplyPackage');
export const ADOPT_ROUTE = routeFor('platform', 'Tenants_adoptPackage');
export const PACKAGES_ROUTE = routeFor('platform', 'Packages_list');
export const PACKAGE_WRITE_ROUTE = routeFor('platform', 'Packages_update');
export const PACKAGE_CREATE_ROUTE = routeFor('platform', 'Packages_create');
export const PACKAGE_RETIRE_ROUTE = routeFor('platform', 'Packages_retire');
export const USAGE_ROUTE = routeFor('platform', 'Metering_usage');
export const ANNOUNCEMENTS_ROUTE = routeFor('platform', 'Announcements_list');
export const ANNOUNCEMENT_PUBLISH_ROUTE = routeFor('platform', 'Announcements_publish');
